import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { tomos, bonos } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function ContentSection() {
  return <section id="incluye" className="scroll-mt-4 bg-noche px-5 py-14 sm:px-8 lg:py-18" data-id="element-10" data-mp="qqd9gbv4j2dd">
      <div className="mx-auto max-w-6xl" data-id="element-11" data-mp="ls1wvtdg2drg">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} className="max-w-2xl" data-id="element-12" data-mp="lr8xxekq8sjv">
          <h2 className="font-display text-2xl font-black uppercase leading-tight text-crudo sm:text-3xl lg:text-4xl" data-id="element-13" data-mp="724fbwa0smb8">
            Todo lo que necesitás para aprender el oficio
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-aluminio sm:text-base" data-id="element-14" data-mp="3u7vd073v5n7z">
            Un recorrido organizado para avanzar paso a paso.
          </p>
        </motion.div>

        {/* Tomos */}
        <ul className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-15" data-mp="3hk2e76fnc082">
          {tomos.map((tomo, index) => <motion.li key={tomo.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: Math.min(index, 5) * 0.04,
          ease: EASE
        }} className="overflow-hidden rounded-xl border border-crudo/10 bg-industrial" data-id="element-16" data-mp="3mcc80xjvtkfm" data-mpi={index}>
              <img src={tomo.image} alt={tomo.alt} className="aspect-[3/4] w-full object-cover" loading="lazy" data-id="element-17" data-mp="3ranj1blwy0zf" />
              <div className="p-3" data-id="element-18" data-mp="2fv8g7r70wewe">
                <p className="font-display text-[0.65rem] font-extrabold uppercase tracking-wider text-electrico-light" data-id="element-19" data-mp="2fu6yx4zeyw68">
                  Tomo {tomo.number}
                </p>
                <h3 className="mt-1 font-display text-xs font-bold leading-snug text-crudo sm:text-sm" data-id="element-20" data-mp="20sqe640tmicw">
                  {tomo.title}
                </h3>
              </div>
            </motion.li>)}
        </ul>

        {/* Bonos */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} className="mt-10" data-id="element-21" data-mp="1ry2c0mqjlgsb">
          <h3 className="font-display text-lg font-black uppercase tracking-wide text-electrico-light sm:text-xl" data-id="element-22" data-mp="1d24ilc806qjs">
            + 6 Bonos prácticos
          </h3>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-23" data-mp="193587c3i61ky">
            {bonos.map(bono => <li key={bono} className="flex items-center gap-2.5 rounded-lg border border-crudo/10 bg-industrial px-3.5 py-3 text-sm text-aluminio" data-id="element-24" data-mp="144ama1a8nwwm">
                <GiftIcon className="h-4 w-4 shrink-0 text-verde-light" aria-hidden="true" data-id="element-25" data-mp="2ye4imvso8jg3" />
                {bono}
              </li>)}
          </ul>
        </motion.div>

        {/* Value summary — no checkout here */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} className="mt-10 rounded-2xl border border-electrico/40 bg-electrico/10 px-5 py-6 text-center" data-id="element-26" data-mp="3fre81lxzz7sn">
          <p className="font-display text-lg font-black uppercase tracking-wide text-crudo sm:text-2xl" data-id="element-27" data-mp="2wz1wc8lgeu5u">
            6 Tomos + 6 Bonos
          </p>
          <p className="mt-1.5 font-display text-sm font-extrabold uppercase tracking-[0.18em] text-electrico-light sm:text-base" data-id="element-28" data-mp="311ykeetrjih6">
            12 recursos digitales
          </p>
        </motion.div>

        <p className="mx-auto mt-6 max-w-xl text-center text-sm leading-relaxed text-aluminio/70" data-id="element-29" data-mp="g8lct4vfveat">
          Y si querés llevar tus conocimientos todavía más lejos, seguí bajando
          para conocer la versión PRO. ↓
        </p>
      </div>
    </section>;
}